import { render, staticRenderFns } from "./TopicAssignmentSubmission.vue?vue&type=template&id=60c37ac8"
import script from "./TopicAssignmentSubmission.vue?vue&type=script&lang=js"
export * from "./TopicAssignmentSubmission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports